import { render, staticRenderFns } from "./ChooseAreaMulti.vue?vue&type=template&id=2f5d2e09&scoped=true"
import script from "./ChooseAreaMulti.vue?vue&type=script&lang=js"
export * from "./ChooseAreaMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d2e09",
  null
  
)

export default component.exports